import { Stack } from "@mui/material";
import type { Product } from "../../components/productDetails/ProductDetails";
import ProductDetails from "../../components/productDetails/ProductDetails";
import CalculationProductAlternatives from "../alternativeProducts/CalculationProductAlternatives";
import type { CalculationProduct } from "../calculationTypes";
import type { FC, PropsWithChildren } from "react";
import type { Currency } from "../../data/BaseEntity";

interface Props {
  readonly selectedProduct: CalculationProduct;
  readonly productDetails: Product | undefined;
  readonly calculationCurrency: Currency | undefined;
  readonly calculationMargin: number | undefined;
  readonly participantsNumber: number;
  readonly readonly?: boolean;
  readonly onReplace: (replacement: CalculationProduct) => void;
}

const CalculationProductName: FC<PropsWithChildren<Props>> = ({
  children,
  selectedProduct,
  productDetails,
  calculationCurrency,
  calculationMargin,
  participantsNumber,
  readonly,
  onReplace,
}) => {
  return (
    <Stack direction="column">
      {children}
      <Stack direction="row">
        <ProductDetails product={productDetails} />
        <CalculationProductAlternatives
          readonly={readonly}
          selectedProduct={selectedProduct}
          calculationCurrency={calculationCurrency}
          calculationMargin={calculationMargin}
          participantsNumber={participantsNumber}
          onReplace={onReplace}
        />
      </Stack>
    </Stack>
  );
};

export default CalculationProductName;
